// extracted by mini-css-extract-plugin
module.exports = {"menuBackground":"#0A0A0A","loginBackground":"#5F5E5E"};